/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var select2: any;
namespace Nobox.NoBoxCRM {
    
    @Serenity.Decorators.registerClass()
    export class JsonImportDialog extends NoboxEntityDialog<any, any> {
        protected form = new JsonImportForm(this.idPrefix);
        public grid: any;

        constructor() {
            super();
        }

        protected updateTitle(): void {
            super.updateTitle();
        }

        dialogOpen() {
            super.dialogOpen();
            $(".s-Nobox-Nobox-JsonImportDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Import Json");
            Q.Router.replace("");
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons = [];
            buttons.push({
                title: 'Download Template',
                hint: 'Download Template',
                separator: true,
                icon: "fa-download text-green",
                onClick: () => {
                    window.open(`${Q.resolveUrl('~/upload/Template/') + 'FormImportTemplate.json'}`)
                }
            });
            return buttons;
        }

        protected getDialogButtons() {
            var $this = this;
            var buttons = super.getDialogButtons();
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        JsonlImportService.JsonImport({
                            FileName: this.form.FileName.value.Filename
                        }, response => {
                            var dlg = new FormJsonDialog();
                            dlg.item = response.data;
                            dlg.loadNewAndOpenDialog();
                            this.dialogClose();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}